import { FormGroup } from '@angular/forms';
import { FormularioRelatorio } from '../interfaces';

export function getCampoAgrupamento(agrupamento: string): FormularioRelatorio {
	return agrupamento === 'BACIA_SUBBACIA'
		? FormularioRelatorio.BACIA
		: FormularioRelatorio[agrupamento as keyof typeof FormularioRelatorio];
}

export function isEstadoCompleto(
	form: FormGroup,
	agrupamento: string
): boolean {
	const campo = getCampoAgrupamento(agrupamento);

	return form?.get(campo)?.value === '0';
}
